import React, {useContext, useState} from 'react';
import {AppContext} from "../context/app-context";
import NavMenu from "../views/nav-menu/NavMenu";
import {Link, useLocation} from "react-router";
import MobileMenu from './MobileMenu';
import {hasAdminAccess, isAdminAccount, isBuyerAccount} from "../util/AccountUtils";
import {NavMenuItemType} from "../views/nav-menu/NavMenuSubmenuListItem";
import {useSticky} from "../hooks/useSticky";

interface BaseNavProps {
  leftNavOptions?: NavMenuItemType[];
  rightNavOptions: NavMenuItemType[];
  fontColorOverride?: boolean;
  logoUrl: string;
}

const BaseNav: React.FC<BaseNavProps> = ({
                                           leftNavOptions = [],
                                           rightNavOptions,
                                           fontColorOverride = false,
                                           logoUrl
                                         }) => {
  const context = useContext(AppContext)
  const {isSticky} = useSticky();
  const {user} = context
  const [showMenu, setShowMenu] = useState(false);
  const [expanded, setExpanded] = useState("");
  const location = useLocation();

  function closeNavMenu() {
    setShowMenu(false)
  }

  function handleClick(name: string) {
    if (name === expanded) {
      return setExpanded("")
    }
    setExpanded(name);
  }

  const isPathVisitedByAdmin = (pathname: string): boolean => {
    return hasAdminAccess(user) && !isAdminAccount(user) && location.pathname === pathname;
  };

  return (
    <>
      <div id="appNav"
           className={`user-based-nav-container ${isSticky ? 'sticky' : ''} ${isPathVisitedByAdmin('/about') && `ss-margin-top`} ${!fontColorOverride ? `ss-other-page-nav` : `ss-nav-menu`} ${isPathVisitedByAdmin('/') && `ss-margin-none`}`}>
        <Link id="navLogoContainer" to="/">
          <img id="navLogoTrans"
               src={isSticky ? `/app-images/logo/secure-space_white-blue_WTG.svg` : logoUrl}
               alt="SecurSpace"/>
        </Link>
        <div id="navMenuContainerRight">
          <div id={`${location.pathname === '/' ? `ss-light_menu_for_landing_page` : `toggleMenuIcon`}`}
               onClick={() => setShowMenu(true)}/>
          <NavMenu
            navMenu={rightNavOptions}
            closeNavMenu={() => setShowMenu(false)}
            overrideFontColor={fontColorOverride}
            isSticky={isSticky}
            buyerSpaceUsageRedesign={isBuyerAccount(user)}
          />
        </div>
      </div>
      <MobileMenu
        closeNavMenu={closeNavMenu}
        handleClick={handleClick}
        leftNavOptions={leftNavOptions}
        rightNavOptions={rightNavOptions}
        showMenu={showMenu}
        expanded={expanded}
        buyerSpaceUsageRedesign={isBuyerAccount(user)}
      />
    </>
  )
}

export default BaseNav;
